import { useQuery } from 'react-query'

import { currencyRepository } from '@webapp/core/data-access/repositories/CurrencyRepository'

export const useCurrencySelect = () => {
  const { data, isFetching } = useQuery({
    queryKey: ['selects', 'currencies'],
    queryFn: () => {
      return currencyRepository.getAllActive()
    },
    cacheTime: Infinity,
  })

  return {
    data: {
      currencies: data || [],
    },
    states: {
      isFetching,
    },
  }
}
